<template>
    <span>
        <table style="border-collapse: collapse;" class="bordered">
            <tr :class="!version_id ? 'selected' : ''">
                <td>Most recent</td>
                <td>
                    <a :href="getUrl(null)">
                        Open version
                    </a>
                </td>
            </tr>

            <tr v-for="d in data" :class="version_id == d.id ? 'selected' : ''">
                <td>{{ d.from }}, {{ d.changed_by_name }}</td>
                <td>
                    <a :href="getUrl(d.id)">
                        Open version
                    </a>
                </td>
            </tr>
        </table>
    </span>
</template>

<style scoped>
    .bordered {
        width: 100%;
    }
    .bordered td {
        border: 1px solid black;
    }
    .selected {
        background: yellowgreen;
    }
</style>

<script>
    export default {
        props: [
            'data',
            'version_id'
        ],
        data() {
            return {
                'overrides': ''
            }
        },
        methods: {
            getUrl(id) {
                let versionSuffix = id ? '?version=' + id : '';

                return window.location.origin + window.location.pathname + versionSuffix;
            }
        }
    }
</script>
